/** Formats a minutes value as "1 min" or "N mins", or an empty string when it is not a positive number. */
export function formatDuration(value: string | number | undefined): string {
   if (value === undefined || value === '') return ''
   const minutes = Number(value)
   if (isNaN(minutes) || minutes <= 0) return ''
   return minutes === 1 ? '1 min' : `${value} mins`
}

/** Parses a typed minutes entry, accepting whole positive numbers only so the PDF preprocessor can read it back. */
export function parseMinutes(input: string): number | null {
   const trimmed = input.trim()
   if (!/^\d+$/.test(trimmed)) return null
   const minutes = Number(trimmed)
   return minutes > 0 ? minutes : null
}
